(function (angular) {

  angular.module("alk.marketing", []);

})(window.angular);


// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-marketing/module.js